module.exports = __webpack_public_path__ + "img/61.a661961.jpg";